import { useQuery } from '@apollo/client';
import { CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1Document } from '../../../../../generated';
import { ComponentQueryLoader } from '../../../../shared/component-query-loader';
import { useParams } from 'react-router-dom';
import { SectionLayout } from './section-layout';
import { PageLayoutProps } from '../../../staff';

interface SectionLayoutContainerProps {
    pageLayouts: PageLayoutProps[];
    isApplicantSection?: boolean;
}

export const SectionLayoutContainer: React.FC<SectionLayoutContainerProps> = (props) => {
    const params = useParams();
  const { caseId } = params;

  const { data: caseStateData, loading: caseStateLoading, error: caseStateError } = useQuery(CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1Document, 
    {
        variables: {
          credentialVerificationCaseV1Id: caseId,
        },
      }
  );


  return (
    <ComponentQueryLoader
      error={caseStateError}
      loading={caseStateLoading}
      hasData={caseStateData !== undefined}
      hasDataComponent={
        <SectionLayout caseState={caseStateData?.credentialVerificationCaseV1?.state ?? ""} pageLayouts={props.pageLayouts}  caseId={caseId ?? ""}  caseName={caseStateData?.credentialVerificationCaseV1?.caseName ?? ""} isApplicantSection={props.isApplicantSection} />
      }
    />
  );
};
